import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { ALink, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";
import { space } from "styled-system";

export const GuideLinesPageContent = (props) => {
  const { webMode = false } = props || {};

  return (
    <Container flexDirection={"column"}>
      {webMode && (
        <Typography
          fontFamily={"var(--font-500)"}
          color={theme.colors.gray_100}
          variant="heading1"
        >
          Shyft’s Community Guidelines
        </Typography>
      )}
      <Wrapper flexDirection={"column"} showHeightGap={webMode}>
        <Typography
          variant="paragraph2"
          fontFamily={"var(--font-400)"}
          color={theme.colors.gray_100}
        >
          We want Shyft communities to remain a genuine, secure, and caring
          space for members to get and give emotional support and share their
          health journeys. By being respectful of everyone's thoughts and
          experiences, you can help us build a supportive community.
        </Typography>
        <Typography
          variant="paragraph2"
          fontFamily={"var(--font-400)"}
          color={theme.colors.gray_100}
        >
          We established the Community Guidelines to ensure that all our members
          are treated with respect and dignity.
        </Typography>
        <Typography
          variant="paragraph2"
          fontFamily={"var(--font-400)"}
          color={theme.colors.gray_100}
        ></Typography>
        <OL pl={"0px"}>
          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              Being kind & considerate
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Please be respectful, considerate, and kind in all your
                  interactions with community members.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  We encourage you to treat everyone with the same respect when
                  posting messages on Communities as you would when speaking to
                  them in person.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Please keep in mind how difficult it can be for people to talk
                  about their experiences and that we could all use some moral
                  support.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  The use of profanity, hate speech, or slurs is not acceptable.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  If you disagree with a community member, you are free to share
                  your thoughts, but do so in a way that does not offend or hurt
                  the poster's sentiments.
                </Typography>
              </LI>
            </OL>
          </LI>
          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              Respecting privacy
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  We value our members' right to privacy. Therefore, please
                  refrain from posting any personally identifiable information
                  about others on this platform.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Don't share personal information : While discussing
                  experiences related to your own physical/mental wellbeing, it
                  is encouraged that you exercise caution when sharing personal
                  details like contact numbers. This is to ensure your safety.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              Avoiding irrelevant or inappropriate content
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  At the moderator's discretion, conversations about unrelated
                  or irrelevant subjects may be ended.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Please don’t share inappropriate content in the form of
                  obscene, racist, sexist, disablist, ageist, homophobic, or
                  transphobic posts. Such posts will be deleted.
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Spamming: Posting irrelevant content such as advertisements is
                  strictly prohibited. These posts will be deleted.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              Avoid giving or taking medical advice
            </Heading>
            <OL>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Members should refrain from providing medical advice as it can
                  potentially lead to misdiagnosis/mismanagement of a patient’s
                  condition which could cause harm.
                </Typography>
              </LI>
              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  None of the posts shared by other Community members in the
                  form of opinions, suggestions or any other content should be
                  considered as medical advice. We recommend that you consult
                  your medical service provider before implementing anything
                  that you read on the Community.
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              Reporting problematic posts
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                The report button is located above each post, and you can use it
                to inform us about any of the following.
              </Typography>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Personal attacks
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Posts including hate speech of any kind
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Trolling, misleading or deliberately inflammatory behavior
                </Typography>
              </LI>

              <LI>
                <Typography
                  fontFamily={"var(--font-400)"}
                  variant="paragraph2"
                  color={theme.colors.gray_100}
                >
                  Spamming
                </Typography>
              </LI>
            </OL>
          </LI>

          <LI>
            <Heading variant="paragraph2" color={theme.colors.gray_100}>
              Reaching out for help
            </Heading>
            <OL>
              <Typography
                fontFamily={"var(--font-400)"}
                variant="paragraph2"
                color={theme.colors.gray_100}
              >
                If you are unsure whether something needs to be reported or
                anything has made you uncomfortable, please feel free to reach
                out to us at <Strong>communities@betheshyft.com.</Strong> Our
                team will do their best to resolve your concerns.
              </Typography>
            </OL>
          </LI>
        </OL>
      </Wrapper>
      <GlobalCss />
    </Container>
  );
};

const Heading = styled(Typography)`
  text-decoration: underline;
  font-family: var(--font-400);
`;
const Container = styled(FlexContainer)`
  margin: 40px auto auto;
`;
const AlphaList = styled.li`
  list-style-type: ${({ capital }) =>
    capital ? "upper-alpha" : "lower-alpha"};
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0px;
  }
`;
const RomanList = styled.li`
  list-style-type: lower-roman;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0px;
  }
`;
const Wrapper = styled(FlexDiv)`
  padding: ${(props) => {
    return props.showHeightGap ? "110px 0px" : "10px 0px 50px 0px";
  }};
  p {
    margin-bottom: 11px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;
const OL = styled.ol`
  ${space}
  padding-inline-start: 40px !important;
  counter-reset: item;
  > li {
    padding-left: 0px;
    li {
      padding-left: 0px;
    }
    ${AlphaList} {
      padding-left: 0;
    }
    ${Heading} {
      margin-bottom: 25px;
    }
  }
`;
const LI = styled.li`
  ${space}
  display: block;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0px;
  }
  position: relative;
  &:before {
    display: inline-block;
    float: left;
    margin-right: 5px;
    content: counters(item, ".") ".";
    counter-increment: item;
    font-size: 12px;
    font-family: var(--font-400);
    color: ${theme.colors.gray_100};
    @media only screen and (min-width: 640px) {
      font-size: 14px;
    }
    @media only screen and (min-width: 960px) {
      font-size: 16px;
    }
  }
`;
const Strong = styled.strong`
  font-size: inherit;
  font-family: var(--font-700);
  color: inherit;
`;
const SUBOL = styled(OL)`
  counter-reset: item;
`;
const Link = styled(ALink)`
  font-size: inherit;
  font-family: inherit;
  color: ${theme.colors.dotsColor};
  ${({ isNormal }) =>
    !isNormal &&
    `
    font-style: italic;
  `};
  &:hover {
    color: ${theme.colors.dotsColor};
  }
`;
const ItalicText = styled.i`
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  font-style: italic;
`;
const GlobalCss = createGlobalStyle`
::marker {
    font-size: 12px;
    color: ${theme.colors.gray_100};
    font-family: 'Raleway',sans-serif;
    @media only screen and (min-width: 640px) {
    font-size: 14px;
    }
    @media only screen and (min-width: 960px) {
    font-size: 16px;
    }

    
}
  `;
